"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvelopeIcon = EnvelopeIcon;
const jsx_runtime_1 = require("react/jsx-runtime");
function EnvelopeIcon({ title, titleId, decorative, ...props }) {
    return ((0, jsx_runtime_1.jsxs)("svg", { viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props, children: [title && !decorative && (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }), (0, jsx_runtime_1.jsx)("path", { d: "M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z", fill: "currentColor" })] }));
}
